import 'antd/dist/antd.css';
import ReactOnRails from 'react-on-rails';
import TicketsIndex from '../src/tickets-index';
import ApplicationHeader from '../src/application-header';
import ApplicationFooter from '../src/application-footer';
import LoginsNew from '../src/logins-new';
import BoardsIndex from '../src/boards-index';
import SettingsTelegramUpdates from '../src/settings-telegram-updates';
import SettingsShow from '../src/settings-show';
import ChatsIndex from '../src/chats-index';
import ChatsShow from '../src/chats-show';

ReactOnRails.register({
  ApplicationHeader,
  ApplicationFooter,
  TicketsIndex,
  LoginsNew,
  BoardsIndex,
  SettingsTelegramUpdates,
  SettingsShow,
  ChatsIndex,
  ChatsShow,
});
